import { SurveyCategory } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { SurveysContext } from '@/contexts/indications'

interface UseSurveyCategoriesProps {
  surveyCategories: SurveyCategory[]
  currentSurveyCategory: SurveyCategory | null
  updateIndicationCategory: (surveyCategory: SurveyCategory | null) => void
}

export const useSurveyCategories = (): UseSurveyCategoriesProps => {
  const { surveyCategories, currentSurveyCategory, setCurrentSurveyCategory: setCurrentIndicationCategory } = useContext(SurveysContext)

  const updateIndicationCategory = (indicationCategory: SurveyCategory | null) => {
    setCurrentIndicationCategory(indicationCategory)
  }

  return {
    surveyCategories,
    currentSurveyCategory,
    updateIndicationCategory
  }
}
